import React, { useEffect, useState } from "react";

/**
 * Typewriter-Schlagwort im Ducket-Stil: tippt ein Wort, pausiert,
 * loescht es und tippt das naechste – mit blinkendem Cursor.
 */
export const RotatingKeyword = ({ words = [], className = "" }) => {
  const [wordIndex, setWordIndex] = useState(0);
  const [text, setText] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    if (!words.length) return undefined;
    const word = words[wordIndex % words.length];
    let delay = deleting ? 40 : 85;
    if (!deleting && text === word) delay = 2000;
    else if (deleting && text === "") delay = 350;
    const t = setTimeout(() => {
      if (!deleting && text === word) { setDeleting(true); return; }
      if (deleting && text === "") {
        setDeleting(false);
        setWordIndex((i) => (i + 1) % words.length);
        return;
      }
      setText(word.slice(0, text.length + (deleting ? -1 : 1)));
    }, delay);
    return () => clearTimeout(t);
  }, [text, deleting, wordIndex, words]);

  if (!words.length) return null;
  return (
    <span className={`rotating-keyword ${className}`} data-testid="rotating-keyword">
      {text || "\u00A0"}
      <span className="rk-cursor" aria-hidden="true" />
    </span>
  );
};

export default RotatingKeyword;
